import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSetAtom } from 'jotai';
import { commonSnackbarPropsAtom } from '../state/state';

export interface CopyToClipboardProps {
  textToCopy: string;
  children: React.ReactElement;
}

export default function CopyToClipboard({ textToCopy, children }: CopyToClipboardProps): React.JSX.Element {
  const { t } = useTranslation('common');
  const setCommonSnackbarProps = useSetAtom(commonSnackbarPropsAtom);

  const handleCopy = async (): Promise<void> => {
    await navigator.clipboard.writeText(textToCopy);
    setCommonSnackbarProps({
      label: t('common:copied'),
      snackbarProps: {
        open: true,
      },
    });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={textToCopy} placement="top-start">
        {children}
      </Tooltip>
      <IconButton size="small" onClick={handleCopy}>
        <ContentCopyIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
}
